import { Component, Input, OnInit } from '@angular/core';

export interface CardContent {
  title: string;
  subtitle?: string;
  content?: string;
  image_source?: string;
  image_link?: string;
  button_icon?: string;
  button_link?: string;
  sections?: string[];
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() content: CardContent;

  constructor() { }

  ngOnInit(): void {
  }

}
